import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import FileDownload from "material-ui/svg-icons/file/file-download";

import { accounts, users, campaigns, transactions, bills } from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import {
  Page,
  PageSection,
  PageMenu,
  PageBlock,
  RightDrawer
} from "components/Page";
import Price from "components/Formaters/Price";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import ModeEdit from "material-ui/svg-icons/editor/mode-edit";
import Delete from "components/Buttons/Delete";
import Field from "components/Form/Field";
import FlatButton from "material-ui/FlatButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import ClickableRowColumn from "components/Grid/ClickableRowColumn";
import ClickableRow from "components/Grid/ClickableRow";
import TransationFormDialog from "components/Balance/TransationFormDialog";
import BillFormDialog from "components/Balance/BillFormDialog";
import * as os from "osutil";

class AccountDetails extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  state = { tab: "account", open: false, selected_bills: [] };

  tabs = [
    { label: "Översikt", key: "account" },
    { label: "Användare", key: "users" },
    { label: "Kampanjer", key: "campaigns" },
    { label: "Transaktioner", key: "transactions" },
    { label: "Fakturor", key: "bills" }
  ];

  handleNav = e => {
    this.setState({ ...this.state, tab: e });
  };

  onBillRowSelection = rows => {
    console.log(rows);
    var selected_bills = rows.map(i => this.props.bills[i]).filter(r => !!r);
    console.log(selected_bills);
    this.setState({ selected_bills: selected_bills });
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/accounts");
  }

  openTransactionDialog = () => {
    this.transactionDialog.getWrappedInstance().openDialog();
  };

  openBillDialog = () => {
    this.billDialog.getWrappedInstance().openDialog();
  };

  closeDialog = event => {
    var state = { ...this.state, open: false };
    this.setState(state);
  };

  addUser = e => {
    alert("Förnärvarande kan kontot endast ha en användare.");
  };

  addCampaign(e) {
    this.props.actions.createCampaign(this.props.params.id, {
      created: new Date().getTime(),
      updated: new Date().getTime(),
      status: "draft",
      name: "New campaign"
    });
  }

  componentWillMount() {
    this.props.actions.fetchAccount(this.props.params.id);
    this.props.actions.fetchCampaigns(this.props.params.id);
    this.props.actions.fetchTransactions(this.props.params.id);
    this.props.actions.fetchBills(this.props.params.id);
    this.props.actions.fetchUsers();
  }

  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(this.props.account, ...data);

    this.props.actions.updateAccount(this.props.params.id, merged);
  }

  renderMembers = function() {
    return _.map(this.props.members, (user, key) => {
      var registeredDate = os.formatDate(user.registered);
      return (
        <TableRow key={key}>
          <TableRowColumn>{user.info.email}</TableRowColumn>
          <TableRowColumn>{registeredDate}</TableRowColumn>
          <TableRowColumn>{user.role}</TableRowColumn>
          <TableRowColumn>
            <ModeEdit />
            <Delete />
          </TableRowColumn>
        </TableRow>
      );
    });
  };

  renderCampaigns = campaigns => {
    if (!campaigns || campaigns.length === 0) {
      return (
        <ClickableRow>
          <ClickableRowColumn>Inga kampanjer</ClickableRowColumn>
        </ClickableRow>
      );
    }

    return _.map(campaigns, (campaign, key) => {
      var count = campaign.bookings ? Object.keys(campaign.bookings).length : 0;
      var amount = campaign.details.amount ? campaign.details.amount : 0;
      return (
        <ClickableRow key={key}>
          <ClickableRowColumn>{campaign.details.name}</ClickableRowColumn>
          <ClickableRowColumn>{count} annonser</ClickableRowColumn>
          <ClickableRowColumn>
            <Price value={amount} />
          </ClickableRowColumn>
        </ClickableRow>
      );
    });
  };

  renderTransactions = transactions => {
    if (!transactions || transactions.length === 0) {
      return (
        <ClickableRow>
          <ClickableRowColumn>Inga transaktioner</ClickableRowColumn>
        </ClickableRow>
      );
    }

    return _.map(transactions, (transaction, key) => {
      var count = 0,
        price = 0,
        date = 0;
      var description = "";
      var created = transaction.created
        ? os.formatDateTime(transaction.created)
        : "";

      return (
        <ClickableRow key={key}>
          <ClickableRowColumn>{created}</ClickableRowColumn>
          <ClickableRowColumn>{transaction.description}</ClickableRowColumn>
          <ClickableRowColumn>
            <Price value={transaction.amount} />
          </ClickableRowColumn>
        </ClickableRow>
      );
    });
  };

  renderBills = bills => {
    if (!bills || bills.length === 0) {
      return (
        <ClickableRow>
          <ClickableRowColumn>Inga fakturor</ClickableRowColumn>
        </ClickableRow>
      );
    }

    return _.map(bills, (bill, key) => {
      var count = 0,
        price = 0,
        date = 0;
      var description = "";
      var created = bill.created ? os.formatDateTime(bill.created) : "";
      var link = bill.pdf ? (
        <a download href={bill.pdf}>
          <FileDownload />
        </a>
      ) : null;
      var key = bill.key;
      console.log("bill key", bill.key);
      return (
        <ClickableRow key={bill.key}>
          <ClickableRowColumn>{created}</ClickableRowColumn>
          <ClickableRowColumn>{bill.description}</ClickableRowColumn>
          <ClickableRowColumn>
            <Price value={bill.amount} />
          </ClickableRowColumn>
          <ClickableRowColumn>{bill.ocr}</ClickableRowColumn>
          <ClickableRowColumn>{link}</ClickableRowColumn>
        </ClickableRow>
      );
    });
  };

  render() {
    if (!this.props.account) {
      return null;
    }

    var {
      orgname,
      orgphone,
      orgemail,
      orgnum,
      street,
      zip,
      city
    } = this.props.account;
    return [
      <RightDrawer key="right">
        <PageBlock label={`Konto: ${this.props.account.orgname}`}>
          <PageMenu onNav={this.handleNav} tabs={this.tabs} title="Konto" />
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        {this.state.tab === "account" && (
          <PageSection
            onSubmit={this.handleFormSubmit.bind(this)}
            className="form-inline"
          >
            <PageBlock right={true} label={orgname}>
              <Row>
                <Field
                  floatingLabelText="Organisationsnummer"
                  ref="orgnum"
                  value={orgnum}
                />
              </Row>
              <Row>
                <Field
                  floatingLabelText="Företagsnamn"
                  ref="orgname"
                  value={orgname}
                />
              </Row>
              <Row>
                <Field
                  floatingLabelText="E-postadress"
                  ref="orgemail"
                  value={orgemail}
                />
              </Row>
              <Row>
                <Field
                  floatingLabelText="Telefon"
                  ref="orgphone"
                  value={orgphone}
                />
              </Row>
              <Row>
                <Field
                  floatingLabelText="Gatuadress"
                  ref="street"
                  value={street}
                />
              </Row>
              <Row>
                <Field floatingLabelText="Postnummer" ref="zip" value={zip} />
              </Row>
              <Row>
                <Field floatingLabelText="Postort" ref="city" value={city} />
              </Row>
              <Row styleName="padded">
                <RaisedButton
                  onTouchTap={this.handleFormSubmit.bind(this)}
                  primary={true}
                  label="Spara"
                />
                <RaisedButton
                  onTouchTap={this.handleCancel.bind(this)}
                  label="Stäng"
                />
              </Row>
            </PageBlock>
            <PageBlock label="Företag" />
          </PageSection>
        )}
        {this.state.tab === "users" && (
          <PageSection>
            <PageBlock right={true} label="Användare">
              <Row />

              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn>E-post</TableHeaderColumn>
                    <TableHeaderColumn>Registrerad</TableHeaderColumn>
                    <TableHeaderColumn>Roll</TableHeaderColumn>
                    <TableHeaderColumn />
                  </TableRow>
                </TableHeader>
                <TableBody>{this.renderMembers()}</TableBody>
              </Table>
            </PageBlock>
            <PageBlock label="Översikt">
              <RaisedButton
                onTouchTap={e => this.addUser()}
                label="Lägg till användare"
              />
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "campaigns" && (
          <PageSection>
            <PageBlock label="Översikt">
              <RaisedButton
                onTouchTap={e => this.addCampaign()}
                label="Ny kampanj"
              />
            </PageBlock>
            <PageBlock right={true} label="Kampanjer">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn>Produkt</TableHeaderColumn>
                    <TableHeaderColumn>Beställare</TableHeaderColumn>
                    <TableHeaderColumn>Datum</TableHeaderColumn>
                    <TableHeaderColumn />
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.renderCampaigns(this.props.campaigns)}
                </TableBody>
              </Table>
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "transactions" && (
          <PageSection>
            <PageBlock label="Konto">
              <div>
                <p>
                  Saldo:{" "}
                  <b>
                    <Price value={this.props.transactions_sum} />
                  </b>
                </p>
                <p>
                  Antal transaktioner: <b>{this.props.transactions_count}</b>
                </p>
              </div>
              <RaisedButton
                onTouchTap={e => this.openTransactionDialog()}
                label="Manuell transaktion"
              />
            </PageBlock>
            <PageBlock right={true} label="Transaktioner">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn>Datum</TableHeaderColumn>
                    <TableHeaderColumn>Beskrivning</TableHeaderColumn>
                    <TableHeaderColumn>Belopp</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.renderTransactions(this.props.transactions)}
                </TableBody>
              </Table>
              <TransationFormDialog
                ref={e => (this.transactionDialog = e)}
                accountid={this.props.params.id}
              />
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "bills" && (
          <PageSection>
            <PageBlock label="Fakturor">
              <div>
                <p>
                  Saldo:{" "}
                  <b>
                    <Price value={this.props.bills_sum} />
                  </b>
                </p>
                <p>
                  Antal fakturor: <b>{this.props.bills_count}</b>
                </p>
              </div>
              <RaisedButton
                onTouchTap={e => this.openBillDialog()}
                label="Skapa faktura"
              />
            </PageBlock>
            <PageBlock right={true} label="Fakturor">
              <Table multiSelectable onRowSelection={this.onBillRowSelection}>
                <TableHeader>
                  <TableRow>
                    <TableHeaderColumn>Datum</TableHeaderColumn>
                    <TableHeaderColumn>Beskrivning</TableHeaderColumn>
                    <TableHeaderColumn>Belopp</TableHeaderColumn>
                    <TableHeaderColumn>OCR</TableHeaderColumn>
                    <TableHeaderColumn>PDF</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody>{this.renderBills(this.props.bills)}</TableBody>
              </Table>
              <BillFormDialog
                ref={e => (this.billDialog = e)}
                accountid={this.props.params.id}
              />
            </PageBlock>
          </PageSection>
        )}
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  if (!state.accounts) return {};
  var transactions = os.collection_to_array(state.transactions.list.data);
  transactions = transactions.sort(function(a, b) {
    return b.created - a.created;
  });
  var bills = os.collection_to_array(state.bills.list.data);
  return {
    account: state.accounts.details,
    campaigns: state.campaigns.list.data,
    transactions_count: transactions.length,
    transactions_sum: transactions.reduce((a, b) => a + parseInt(b.amount), 0),
    transactions: transactions,
    bills_count: bills.length,
    bills_sum: bills.reduce((a, b) => a + parseInt(b.amount), 0),
    bills: bills,
    members: os.intersect(state.accounts.details.users, state.users.list),
    pending: !state.accounts.details
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...accounts, ...users, ...campaigns, ...transactions, ...bills },
      dispatch
    )
  };
};
export default connect(mapStateToProps, mapDispatch)(AccountDetails);



// WEBPACK FOOTER //
// ./src/pages/admin/accounts/AccountDetails.jsx